export default "__VITE_ASSET__CZrscenq__"